module.exports = __webpack_public_path__ + "CL.png?7657974f2ae6d2e49c87e5dc2390890d";